export function getMetaData() {
  return fetch(`${process.env.ZEUS_API}/signups/metadata`, {
    newErrors: true
  }).then(res => res.json());
}

export function submit(data) {
  return fetch(`${process.env.SIGNUPS_API}/signup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(res => res.json());
}
